export default __webpack_public_path__ + "static/media/p5.85d5f298.png";